// AYA Multiservice — Écran 2 : choix du moyen de paiement (simulation).
import React from "react";
import { ArrowRight, ShieldCheck, Info } from "lucide-react";
import { BrandLogo } from "./BrandLogo";
import { fmtFcfa } from "./multiserviceApi";

export default function PaymentStep({ catalog, draft, patch, total, onContinue, submitting }) {
  const methods = catalog?.payment_methods || [];
  return (
    <div data-testid="ms-payment-step">
      <h2 style={{ fontSize: 18, fontWeight: 800, margin: "4px 0 3px" }}>Choisissez votre moyen de paiement</h2>
      <p style={{ fontSize: 12, color: "#6B8577", margin: "0 0 16px" }}>Sélectionnez comment vous souhaitez régler cette recharge.</p>

      {methods.map((m) => {
        const insufficient = m.id === "aya_wallet" && total > (m.mockBalance || 0);
        return (
          <button key={m.id} className={`ms-pay ${draft.paymentMethodId === m.id ? "sel" : ""} ${insufficient ? "off" : ""}`}
            data-testid={`ms-pay-${m.id}`} disabled={insufficient}
            onClick={() => patch({ paymentMethodId: m.id })}>
            <BrandLogo brand={m.brand} size={42} />
            <span className="ms-pay-body">
              <span className="ms-pay-name">
                {m.name}
                {m.id === "aya_wallet" && <span className="ms-badge-new">NOUVEAU</span>}
                {m.demoOnly && <span className="ms-badge-demo">DÉMO</span>}
              </span>
              <div className="ms-pay-desc">
                {m.id === "aya_wallet"
                  ? `Solde simulé : ${fmtFcfa(m.mockBalance)}${insufficient ? " — insuffisant pour ce montant" : ""}`
                  : m.description}
                {m.fees > 0 ? ` · Frais ${fmtFcfa(m.fees)}` : ""}
              </div>
            </span>
            <span className="ms-radio" />
          </button>
        );
      })}

      <div className="ms-secure-note"><ShieldCheck size={15} /> Paiement simulé de bout en bout — vos données sont protégées.</div>
      <div className="ms-demo-note" data-testid="ms-demo-note"><Info size={15} /> Mode démonstration : aucun paiement réel ne sera effectué.</div>

      <button className="ms-cta" data-testid="ms-payment-continue-btn" disabled={!draft.paymentMethodId || submitting} onClick={onContinue}>
        {submitting ? "Vérification…" : <>Continuer <ArrowRight size={17} /></>}
      </button>
    </div>
  );
}
